import { breakpoints } from './breakpoints';
import { useMediaQueryMatch } from './useMediaQueryMatch';

export const useIsMobile = () => useMediaQueryMatch(breakpoints.smallMobile);
export const useIsDesktop = () => useMediaQueryMatch(breakpoints.tablet);
export const useIsMediumDesktop = () =>
  useMediaQueryMatch(breakpoints.mediumDesktop);
export const useIsLargeDesktop = () =>
  useMediaQueryMatch(breakpoints.largeDesktop);
